(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gi-facets"] && !Shopify.designMode) return;
  try {
    (function () {
    function closeOthers(current) {
      document.querySelectorAll('[data-gi-facets-dropdown][open]').forEach(function (el) {
        if (el !== current) el.removeAttribute('open');
      });
    }

    document.addEventListener('toggle', function (event) {
      var el = event.target;
      if (el instanceof HTMLDetailsElement && el.hasAttribute('data-gi-facets-dropdown') && el.open) {
        closeOthers(el);
      }
    }, true);

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-gi-facets-dropdown]')) closeOthers(null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelector('[data-gi-facets-dropdown][open]');
      if (!open) return;
      open.removeAttribute('open');
      open.querySelector('summary').focus();
    });

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('[data-gi-facets-auto]')) return;
      var form = input.closest('[data-gi-facets-form]');
      if (!form) return;
      form.querySelectorAll('input[type="number"]').forEach(function (field) {
        if (field.value === '') field.disabled = true;
      });
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-gi-facets-form')) return;
      form.querySelectorAll('input[type="number"]').forEach(function (field) {
        if (field.value === '') field.disabled = true;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
